import { render } from "./Solicitante.vue?vue&type=template&id=4fb40472"
import script from "./Solicitante.vue?vue&type=script&lang=js"
export * from "./Solicitante.vue?vue&type=script&lang=js"

import "./Solicitante.vue?vue&type=style&index=0&id=4fb40472&lang=css"
script.render = render

export default script